import React from 'react';

// Types
import { Size } from 'Wpds/components/avatar/WpAvatar';
import { User } from 'Shared/constants/types';

// Constants
import ColorConstants from 'Wpds/colors/ColorConstants';

// Hooks
import { useDeepEqualSelector } from 'Shared/utils/hooks';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

// Selectors
import { getWorkspaceTeammate } from 'Shared/selectors/workspace';

//Components
import WpAvatarGroup from 'Wpds/components/avatar/WpAvatarGroup';
import UserProfilePopover from 'Dashboard/components/UserProfilePopover/UserProfilePopover';

type Props = {
  size?: Size;
  includeeProfilePoover?: boolean;
};

function WorkspaceOneOnOneAvatars({ size = 'lg', includeeProfilePoover = true }: Props) {
  const { workspace } = useWorkspace();
  const users = workspace.users;
  const teammate = useDeepEqualSelector(state => getWorkspaceTeammate(state.workspace.id)(state));
  const isNotInvited = Boolean(!teammate);
  let usersToRender = users;

  if (isNotInvited) {
    const initials = workspace.name.charAt(0).toUpperCase();
    const notInvitedUser = [
      {
        id: Number.MAX_SAFE_INTEGER, // placeholder id for react's key prop
        avatar: { color: ColorConstants.purple[900], initials, profilePictureUrl: '' },
      } as User,
    ];

    usersToRender = [...usersToRender, ...notInvitedUser];
  }

  if (!usersToRender) return null;

  return (
    <WpAvatarGroup users={usersToRender} size={size} popoverDetails={includeeProfilePoover && UserProfilePopover} />
  );
}

export default WorkspaceOneOnOneAvatars;
